// @ts-nocheck

import { v4 } from 'uuid';

import networkActions from '../../../../actions/network';
import { type HandlerProps } from '../../../../store/synchronousMiddleware';
import { RouterActionTypes } from '../../../../types/actions/router';
import RoutesRedirectionFactory from '../../../../utils/routes/RoutesRedirectionFactory';
import { fillTemporaryGRNotification, setGRHomeVisitedIndex } from '../../actions/gr';
import { GRStateActionTypes } from '../../types/actions/gr';
import { GRRoutesActionTypes } from '../../types/actions/routes';

export const handledActionTypes = [
  GRRoutesActionTypes.OPEN_GR_VIEW,
  GRStateActionTypes.FLUSH_NOTIFICATIONS,
  RouterActionTypes.ROUTE_HAS_CHANGED,
  GRStateActionTypes.START,
  GRStateActionTypes.CLAIM_REWARD,
  GRStateActionTypes.RESTART_ROUND,
];

const GRMiddlewareHandler = ({ store: { dispatch, getState }, action, params: { history } }: HandlerProps) => {
  if (handledActionTypes.indexOf(action.type) !== -1) {
    const state = getState();

    if (action.type === GRStateActionTypes.FLUSH_NOTIFICATIONS) {
      const uniqId = v4();
      dispatch(
        networkActions.send({
          giftrace: {
            method: 'flushNotifications',
            id: uniqId,
          },
        }),
      );
    }

    if (action.type === GRStateActionTypes.CLAIM_REWARD) {
      const uniqId = v4();
      dispatch(
        networkActions.send({
          giftrace: {
            method: 'claimReward',
            id: uniqId,
            params: {
              uuid: action.payload?.uuid,
            },
          },
        }),
      );
    }

    if (action.type === GRStateActionTypes.RESTART_ROUND) {
      const uniqId = v4();
      dispatch(
        networkActions.send({
          giftrace: {
            method: 'restartRound',
            id: uniqId,
          },
        }),
      );
    }

    if (action.type === GRStateActionTypes.START) {
      const uniqId = v4();
      dispatch(
        networkActions.send({
          giftrace: {
            method: 'start',
            id: uniqId,
          },
        }),
      );
    }

    if (action.type === GRRoutesActionTypes.OPEN_GR_VIEW) {
      dispatch(fillTemporaryGRNotification());
      history.replace(RoutesRedirectionFactory.getGRRouteConfig());
    }

    if (action.type === RouterActionTypes.ROUTE_HAS_CHANGED) {
      const { payload: { pathname } = {} } = action;

      if (pathname.indexOf(RoutesRedirectionFactory.getGRRoutePathname()) === -1) {
        const { gr } = state;
        const { misc } = gr;
        const { homeVisitedIndex } = misc ?? {};

        if (typeof homeVisitedIndex === 'number') {
          dispatch(setGRHomeVisitedIndex(null));
        }
      }
    }
  }
};

export default GRMiddlewareHandler;
